var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"row justify-md-content-between justify-content-center"},[_c('div',{staticClass:"col-12"},[_c('h1',{staticClass:"text-light text-center"},[_vm._v("Event Genius")])])])])
}]

export { render, staticRenderFns }